import {
	UserSettingsDtoContainerStatus,
	UserSettingsDtoTransportType,
} from '@uturn/api/v1';
import { z } from '@uturn/portal/zod';
import { getRequiredFields } from '@uturn/portal/zod/utils';

/** UserSettingsDto — the default values prefilled on every new shipment. */
// nullish() so a field can be explicitly cleared to null ("no preference").
export const editDefaultValuesSchema = z.object({
	shippingLineId: z.number().nullish(),
	transportType: z.nativeEnum(UserSettingsDtoTransportType).nullish(),
	fixedPrice: z.boolean().nullish(),
	requiresVat: z.boolean().nullish(),
	containerStatus: z.nativeEnum(UserSettingsDtoContainerStatus).nullish(),
});

export type EditDefaultValuesFormValues = z.infer<
	typeof editDefaultValuesSchema
>;

export const requiredFields = getRequiredFields(editDefaultValuesSchema);
